import React, { useEffect, useState } from 'react';
import { getDashboardQueueStatistics } from '../../utils/awsAPI';
import { secondsToHMS } from '../../utils/utils';
import { SiClockify } from "react-icons/si";
import { useSelector } from 'react-redux';

const getCurrentTime = () => {
    const today = new Date();
    
    let hoursNum = today.getHours();
    let hoursStr = hoursNum.toString();

    let minNum = today.getMinutes();
    let minStr = minNum.toString();

    let secNum = today.getSeconds();
    let secStr = secNum.toString();

    if (hoursNum < 10) hoursStr = '0' + hoursStr;
    if (minNum < 10) minStr = '0' + minStr;
    if (secNum < 10) secStr = '0' + secStr;
    
    return `${hoursStr}:${minStr}:${secStr}`;
};

const QueueStatistics = () => {
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const [statsData, setStatsData] = useState<any>([])
    const [timeFrame, setTimeFrame] = useState({'text': 'Today', 'value':'23', 'localTime':getCurrentTime()});

    useEffect(()=>{
        const getDashboardData = async () => {
            let queueList = (agentObj) ? agentObj.getRoutingProfile().queues : [];
            let queueIds = queueList.filter((queue:any) => queue.queueId.indexOf('agent') === -1).map((queue:any) => queue.queueId)
            if(queueIds.length > 0) {
                const QueueStatisticsResponse = await getDashboardQueueStatistics(queueIds, timeFrame.value, timeFrame.localTime);
                if(Object.keys(QueueStatisticsResponse.MetricResults).length > 0) {
                    let finalData:any = [];
                    QueueStatisticsResponse.MetricResults.map((statsData:any) => {
                        let filterData:any = {}
                        let queueName = queueList.filter((queue:any) => queue.queueARN === statsData.Dimensions.Queue.Arn)[0]
                        filterData['queueName'] = queueName.name;
                        filterData['arn'] = statsData.Dimensions.Queue.Arn;
                        let initialState:any = { 'CONTACTS_HANDLED':0, 'CONTACTS_QUEUED':0, 'CONTACTS_ABANDONED':0, 'QUEUED_TIME':0, 'QUEUE_ANSWER_TIME':0, 'HANDLE_TIME':0, 'INTERACTION_TIME':0 };
                        statsData.Collections.map((data:any) => {
                            if(data.Metric.Name === 'CONTACTS_HANDLED'){
                                initialState.CONTACTS_HANDLED = data.Value;
                            } else if(data.Metric.Name === 'CONTACTS_QUEUED'){
                                initialState.CONTACTS_QUEUED = data.Value;
                            } else if(data.Metric.Name === 'CONTACTS_ABANDONED'){
                                initialState.CONTACTS_ABANDONED = data.Value;
                            } else if(data.Metric.Name === 'QUEUED_TIME'){
                                initialState.QUEUED_TIME = data.Value;
                            } else if(data.Metric.Name === 'QUEUE_ANSWER_TIME'){
                                initialState.QUEUE_ANSWER_TIME = data.Value;
                            } else if(data.Metric.Name === 'HANDLE_TIME'){
                                initialState.HANDLE_TIME = data.Value;
                            } else if(data.Metric.Name === 'INTERACTION_TIME'){
                                initialState.INTERACTION_TIME = data.Value;
                            }
                            filterData['collections'] = initialState;
                            return '';
                        })
                        finalData.push(filterData);
                        return ''
                    })
                    setStatsData(finalData)
                }
            }
        }
        getDashboardData();
    },[timeFrame.value, agentObj])

    const onSelectTimeFrame = (event:any,selectedTimeFrame:string,userLocalTime:any) => {
        setTimeFrame({'text': event.target.value, 'value':selectedTimeFrame, 'localTime':userLocalTime})
    }

    return (
        <div className="card wrapup-box collapse show mt-3" id="QueueStatistics">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className='m-0'>Queue statistics</h6>
                <div className='d-flex'>
                    <div className="dropdown">
                        <button type="button" className={`btn btn-sm dropdown-toggle`} data-bs-toggle="dropdown">
                            {timeFrame.text}
                        </button>
                        <ul className="dropdown-menu">
                            <li>
                                <button onClick={ (event)=>{onSelectTimeFrame(event,'1',getCurrentTime())} } value="1 Hour" className="dropdown-item">1 hour</button>
                                <button onClick={ (event)=>{onSelectTimeFrame(event,'3',getCurrentTime())} } value="3 Hours" className="dropdown-item">3 hours</button>
                                <button onClick={ (event)=>{onSelectTimeFrame(event,'6',getCurrentTime())} } value="6 Hours" className="dropdown-item">6 hours</button>
                                <button onClick={ (event)=>{onSelectTimeFrame(event,'23',getCurrentTime())} } value="Today" className="dropdown-item">Today</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <table className='table table-stripted table-striped table-borderless'>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Calls handled</th>
                            <th>Calls queued</th>
                            <th>Calls abandoned</th>
                            <th colSpan={4}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody> 
                        {statsData && statsData.map((stats:any, index:number) =>{
                            return (
                                <tr key={index}>
                                    <td><span className='QueueName'>{stats?.queueName}</span></td>
                                    <td>
                                        <div className='agent-box'>
                                            {/* <span className='agent-icon bg-success'><MdOutlineCall /></span> */}
                                            <span className='agent-count'>{stats?.collections?.CONTACTS_HANDLED}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className='agent-box'>
                                            {/* <span className='agent-icon bg-primary'><MdOutlinePhoneCallback /></span> */}
                                            <span className='agent-count'>{stats?.collections?.CONTACTS_QUEUED}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className='agent-box'>
                                            {/* <span className='agent-icon bg-danger'><MdOutlinePhoneMissed /></span> */}
                                            <span className='agent-count'>{stats?.collections?.CONTACTS_ABANDONED}</span>
                                        </div>
                                    </td>
                                    <td style={{width:"20px"}}><div className='vertical-line'>&nbsp;</div></td>
                                    <td style={{width:"294px"}}>
                                        <div className='d-flex align-items-center'>
                                            <div>
                                                <div className='call-que-time'>{secondsToHMS(stats?.collections?.QUEUED_TIME)}</div>
                                                <div className='call-que-text'>Longest call in queue</div>
                                            </div>
                                            <div className='clock-icon'>
                                                <SiClockify />
                                            </div>
                                            <div>
                                                <div className='call-que-time'>{secondsToHMS(stats?.collections?.QUEUE_ANSWER_TIME)}</div>
                                                <div className='call-que-text'>Average wait time</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{width:"20px"}}><div className='vertical-line'>&nbsp;</div></td>
                                    <td style={{width:"294px"}}>
                                        <div className='d-flex align-items-center'>
                                            <div>
                                                <div className='call-que-time'>{secondsToHMS(stats?.collections?.HANDLE_TIME)}</div>
                                                <div className='call-que-text'>Average handled time</div>
                                            </div>
                                            <div className='clock-icon'>
                                                <SiClockify />
                                            </div>
                                            <div>
                                                <div className='call-que-time'>{secondsToHMS(stats?.collections?.INTERACTION_TIME)}</div>
                                                <div className='call-que-text'>Average answer time</div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default QueueStatistics;